import { atom, PrimitiveAtom } from 'jotai';
import { Swiper as SwiperClass } from 'swiper/types';
import { useScopedAtomValue, useSetScopedAtom } from '@lemon8/webapp-shared';
import { useEffect } from 'react';

type TSwiperOrNot = SwiperClass | null;

export const $MainSwiper = atom<TSwiperOrNot>(null as TSwiperOrNot);
export const $CurrentMainSlide = atom(0);

export const $GallerySwiper = atom<TSwiperOrNot>(null as TSwiperOrNot);
export const $CurrentGallerySlide = atom(0);

export const $EndRecommendSwiper = atom<TSwiperOrNot>(null as TSwiperOrNot);
export const $CurrentEndRecommendSlide = atom(0);

/**
 * bind current-slide atom to a swiper atom.
 */
export const useMountCurrentSlideWithSwiper = (
  $swiper: PrimitiveAtom<TSwiperOrNot>,
  $slide: PrimitiveAtom<number>,
): void => {
  const swiper = useScopedAtomValue($swiper);
  const setSlide = useSetScopedAtom($slide);

  useEffect(() => {
    if (!swiper) {
      return;
    }

    const callback = (swiper: SwiperClass): void => {
      setSlide(swiper.activeIndex);
    };

    swiper.on('slideChange', callback);

    return () => {
      swiper.off('slideChange', callback);
    };
  }, [swiper, setSlide]);
};
